<template>
  <div>
    <v-row align="center" no-gutters class="pt-1 pb-1">
      <v-col cols="2" class="nombre colorHeaders"
        >{{ apellidoAlumno }} {{ nombreAlumno }}</v-col
      >
      <v-col cols="9" class>
        <v-row no-gutters>
          <v-col
            cols="3"
            v-for="grupo in gruposNotas"
            :key="grupo.grupoID"
            class="borde-grupo-notas"
          >
            <v-row justify="center" no-gutters>
              <!-- ---------- Input Promedio General (Final) ---------- -->
              <v-col
                cols="4"
                v-if="grupo.descripcion_grupo == 'examenes'"
                class="textoCentrado"
              >
                <input
                  type="text"
                  :value="formato_numero(promedioGral)"
                  :style="alumnoRegular == 0 ? 'border: solid 2px red;' : ''"
                  class="elevation-3 especial"
                  readonly
                />
              </v-col>
              <v-col
                v-bind:class="[
                  grupo.descripcion_grupo == 'examenes' ? 'xs4' : 'xs2',
                ]"
                v-for="item in grupo.notas"
                :key="item.id"
                class="textoCentrado"
              >
                <!-- ---------- Input Nota Diciembre ---------- -->
                <div v-if="item.descripcion_nota == 'Diciembre'">
                  <input
                    :id="grupo.grupoID + '_' + item.id"
                    type="text"
                    :value="formato_numero(item.nota)"
                    class="elevation-3"
                    v-bind:class="{
                      deshabilitado: !verificarExamenDiciembre(
                        item.fecha_inicio,
                        item.fecha_fin
                      ),
                    }"
                    :readonly="
                      !verificarExamenDiciembre(
                        item.fecha_inicio,
                        item.fecha_fin
                      )
                    "
                    @change="
                      guardarNota(grupo.grupoID, item.id, $event.target.value)
                    "
                    :name="idalumno + '_' + grupo.grupoID + '_' + item.id"
                    placeholder="-"
                    @keypress="soloNumeros"
                    ref="notaDiciembre"
                  />
                </div>

                <!-- ---------- Input Nota Febrero/Marzo ---------- -->
                <div v-else-if="item.descripcion_nota == 'Feb\/Mar'">
                  <input
                    :id="grupo.grupoID + '_' + item.id"
                    type="text"
                    :value="formato_numero(item.nota)"
                    class="elevation-3"
                    v-bind:class="{
                      deshabilitado: !verificarExamenFebMar(
                        item.fecha_inicio,
                        item.fecha_fin,
                        item
                      ),
                    }"
                    :readonly="
                      !verificarExamenFebMar(
                        item.fecha_inicio,
                        item.fecha_fin,
                        item
                      )
                    "
                    @change="
                      verificarNotaFebrero(
                        grupo.grupoID,
                        item.id,
                        $event.target.value
                      )
                    "
                    :name="idalumno + '_' + grupo.grupoID + '_' + item.id"
                    placeholder="-"
                    @keypress="soloNumeros"
                    ref="notaFebMar"
                  />
                </div>

                <!-- ---------- Input Nota  ---------- -->
                <div v-else>
                  <input
                    :id="grupo.grupoID + '_' + item.id"
                    type="text"
                    :value="formato_numero(item.nota)"
                    class="elevation-3"
                    v-bind:class="{
                      deshabilitado: !verificarEdicion(
                        grupo.fecha_inicio,
                        grupo.fecha_fin
                      ),
                    }"
                    :readonly="
                      !verificarEdicion(grupo.fecha_inicio, grupo.fecha_fin)
                    "
                    @change="
                      guardarNota(grupo.grupoID, item.id, $event.target.value)
                    "
                    :name="idalumno + '_' + grupo.grupoID + '_' + item.id"
                    placeholder="-"
                    @keypress="soloNumeros"
                  />
                </div>
              </v-col>
              <!-- ---------- Input Promedio Trimestres ---------- -->
              <v-col
                cols="2"
                class="textoCentrado"
                v-if="grupo.verPromedio != '0'"
              >
                <input
                  type="text"
                  :value="formato_numero(grupo.promedio)"
                  class="elevation-3"
                  v-bind:class="[
                    grupo.promedio >= 7 ? 'aprueba' : 'no_aprueba',
                  ]"
                  readonly
                  placeholder="-"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- ---------- Input Nota Definitiva ---------- -->
      <v-col cols="1">
        <v-row no-gutters>
          <v-col cols="8" class>
            <input
              type="text"
              :value="nota_final"
              :class="[nota_final == 'PREVIA' ? 'no_aprueba' : 'especial']"
              :style="alumnoRegular == 0 ? 'border: solid 2px red;' : ''"
              class="elevation-3"
              readonly
            />
          </v-col>
          <!-- ---------- Icono consolidar nota/etc ---------- -->
          <v-col md="auto" class>
            <template
              v-if="
                !(
                  nota_final == '-' ||
                  nota_final == 'PREVIA' ||
                  !permisoEdicion
                )
              "
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-bind:class="[
                      notaConsolidada
                        ? 'consolidar_icono_yellow'
                        : 'consolidar_icono_green',
                    ]"
                    @click="consolidarNotaFinal"
                    >{{
                      notaConsolidada ? "mdi-star-circle" : "mdi-check-circle"
                    }}</v-icon
                  >
                </template>
                <span>{{
                  notaConsolidada
                    ? "Nota consolidada"
                    : "Consolidar nota alumno"
                }}</span>
              </v-tooltip>
            </template>
            <template v-else-if="alumnoRegular == 0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon color="red" v-on="on">mdi-alpha-l-circle</v-icon>
                </template>
                <span>Alumno libre</span>
              </v-tooltip>
            </template>

            <!--<div
              id="consolidar_nota_div"
              v-bind:class="[
                nota_final == '-' || nota_final == 'PREVIA' || !permisoEdicion
                  ? 'ocultar_elemento'
                  : '',
              ]"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    v-bind:class="[
                      notaConsolidada
                        ? 'consolidar_icono_yellow'
                        : 'consolidar_icono_green',
                    ]"
                    @click="consolidarNotaFinal"
                    >{{
                      notaConsolidada ? "mdi-star-circle" : "mdi-check-circle"
                    }}</v-icon
                  >
                </template>
                <span>{{
                  notaConsolidada
                    ? "Nota consolidada"
                    : "Consolidar nota alumno"
                }}</span>
              </v-tooltip>
            </div>-->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data() {
    return {
      //promedioGral: this.calcularPromedio(),
      promedioGral: "-",
      notaConsolidada: false,
      //examenDiciembre: false,
      //examenFebreroMarzo: false,
      //notaDiciembre: "",
      //notaFebMar: "",
      nota_final: "-",
      nivelPermiso: "", //nivel permiso de quien ve las notas admin/docente/etc
    };
  },
  props: [
    "idalumno",
    "nota_consolidada",
    "nombreAlumno",
    "apellidoAlumno",
    "alumnoRegular",
    "gruposNotas",
    "habilitarEdicion",
    "materia", //idmateriaAgrupamiento
    "permisoEdicion",
  ],
  mounted: function () {
    this.calcularPromedioGeneral();
    this.verificarConsolidacionNota();
    this.cargarNivelPermiso();
    //console.log("Docente -> itemAlumno");
    /*console.log(
      "permisoEdicion: ",
      this.permisoEdicion,
      "habilitarEdicion: ",
      this.habilitarEdicion
    );*/
  },
  computed: {},
  methods: {
    cargarNivelPermiso() {
      let local = window.localStorage.getItem("EPA_AUTH");

      if (local != null) {
        let localJson = JSON.parse(local);
        this.nivelPermiso = localJson.idCategoria;
      }
    },
    verificarEdicion(fecha_inicio, fecha_fin) {
      //return false;
      //console.log(fecha_inicio, fecha_fin, this.permisoEdicion);
      if (this.nivelPermiso < 3 || this.nivelPermiso == 9) {
        return true;
      } else {
        if (this.permisoEdicion) {
          //console.log("1 if", this.permisoEdicion);
          if (
            this.habilitarEdicion &&
            fecha_inicio != null &&
            fecha_fin != null
          ) {
            /*console.log(
            "rango de fecha: ",
            API.enRangoDeFechas(fecha_inicio, fecha_fin),
            fecha_inicio,
            fecha_fin
          );*/
            //console.log("Acaaaaaaaaaa");
            if (
              API.enRangoDeFechas(
                fecha_inicio,
                fecha_fin
              ) /*&&
            this.nota_final == "-"*/
            ) {
              /*console.log(
                "rango de fecha: ",
                API.enRangoDeFechas(fecha_inicio, fecha_fin),
                fecha_inicio,
                fecha_fin
              );*/
              return true;
            } else return false;
          } else if (this.habilitarEdicion && this.nota_final == "-")
            return true;
          else return false;
        } else return false;
      }
    },
    soloNumeros(e) {
      var key = window.event ? e.which : e.keyCode;
      if ((key < 48 || key > 57) && key != 46) {
        e.preventDefault();
      }
    },
    formato_numero: function (numero) {
      if (!isNaN(numero) && numero <= 10) {
        if (numero == 0) {
          numero = "AUS";
        } else {
          numero = parseFloat(numero).toFixed(2);
        }
        return numero;
      } else return "";
    },
    calcularPromedioGeneral: function () {
      var pomedioAux = 0;
      var cantPromedios = 0;

      for (const grupo in this.gruposNotas) {
        if (
          this.gruposNotas[grupo].descripcion_grupo != "examenes" &&
          this.gruposNotas[grupo].verPromedio != "0" &&
          this.gruposNotas[grupo].promedio != "-"
        ) {
          cantPromedios++;
          pomedioAux = pomedioAux + this.gruposNotas[grupo].promedio;
        }
      }

      if (cantPromedios > 0) pomedioAux = pomedioAux / cantPromedios;
      else pomedioAux = "-";

      this.promedioGral = pomedioAux;
      this.calcularNotaFinal();
    },
    guardarNota: function (id_grupo, id_nota, nota) {
      //console.log("Guardar nota: ", nota);
      if (nota <= 10) {
        let params = "idNota=" + id_nota;
        params += "&idGrupoNota=" + id_grupo;
        params += "&idAgrupamientoMateria=" + this.materia;
        params += "&idAlumno=" + this.idalumno;
        params += "&nota=" + nota;

        let resultado = API.enviar("get", "cargarEditarNota", params);

        resultado
          .then((result) => {
            if (result.data.msj == "ok") {
              this.$emit("itemAlumno:recargarNotas");
            }
          })
          .catch((error) => {
            console.log("catch obtenerNotasMateria", error);
          });
      } else {
        //console.log("guardar nota else");
        this.$emit("itemAlumno:mostrarMsjNotaInvalida");
      }
    },
    verificarExamenDiciembre: function (fecha_inicio, fecha_fin) {
      if (this.alumnoRegular == 0) return true;
      if (
        this.verificarEdicion(fecha_inicio, fecha_fin) &&
        this.formato_numero(this.promedioGral) < 7
      )
        return true;
      else return false;
    },
    verificarExamenFebMar: function (fecha_inicio, fecha_fin) {
      //console.log("verificarExamenFebMar !");
      if (
        this.$refs.notaDiciembre != undefined &&
        this.$refs.notaDiciembre != ""
      ) {
        /*console.log(
          "verificarExamenFebMar if !!!",
          this.$refs.notaDiciembre[0].value,
          "-------->",
          this.verificarEdicion(fecha_inicio, fecha_fin),
          this.formato_numero(this.promedioGral) < 7,
          this.formato_numero(this.$refs.notaDiciembre[0].value) < 7 ||
            this.$refs.notaDiciembre[0].value == "AUS"
        );*/
        if (
          this.verificarEdicion(fecha_inicio, fecha_fin) &&
          this.formato_numero(this.promedioGral) < 7 &&
          (this.formato_numero(this.$refs.notaDiciembre[0].value) < 7 ||
            this.$refs.notaDiciembre[0].value == "AUS")
        ) {
          /*console.log(
            "febrero if: ",
            this.verificarEdicion(fecha_inicio, fecha_fin),
            this.formato_numero(this.promedioGral),
            this.formato_numero(this.$refs.notaDiciembre[0].value)
          );*/
          return true;
        }
        //console.log(this.promedioGral, this.notaDiciembre);
        else {
          if (
            this.alumnoRegular == 0 &&
            (this.formato_numero(this.$refs.notaDiciembre[0].value) < 7 ||
              this.$refs.notaDiciembre[0].value == "AUS")
          )
            return true;
          return false;
        }
      }
      //console.log(this.promedioGral, this.notaDiciembre);
    },
    // revisar \\
    calcularNotaFinal: function () {
      //this.examenDiciembre = false;
      //this.examenFebreroMarzo = false;
      //this.nota_final = "-";
      if (this.promedioGral >= 7 && this.alumnoRegular == 1) {
        //console.log("if nota Final");
        this.nota_final = this.formato_numero(this.promedioGral);
      } else if (this.formato_numero(this.$refs.notaDiciembre[0].value) >= 7) {
        this.nota_final = this.formato_numero(
          this.$refs.notaDiciembre[0].value
        );
        //console.log("notaDiciembre -> notaFinal", this.nota_final);
      } else if (this.formato_numero(this.$refs.notaFebMar[0].value) >= 7) {
        this.nota_final = this.formato_numero(this.$refs.notaFebMar[0].value);
      } else {
        //console.log("else -> ", this.$refs.notaFebMar[0].value);
        if (
          this.$refs.notaFebMar[0].value == "-" ||
          this.$refs.notaFebMar[0].value == ""
        )
          this.nota_final = "-";
        else this.nota_final = "PREVIA";
      }
    },
    verificarConsolidacionNota: function () {
      this.notaConsolidada = false;
      if (
        this.nota_consolidada != "-" &&
        this.nota_consolidada != "" &&
        this.nota_consolidada != null
      ) {
        this.notaConsolidada = true;
      }
    },
    consolidarNotaFinal: function () {
      //console.log("consolidarNotaFinal");
      if (!this.notaConsolidada) {
        let params = "idAlumno=" + this.idalumno;
        params += "&idAgrupamientoMateria=" + this.materia;
        params += "&nota=" + this.nota_final;
        params += "&condicion=regular";
        params += "&mes=diciembre";
        //params += "&periodo=" + API.PERIODO_ACTUAL;
        params += "&fecha=" + API.FECHA_ACTUAL;
        params += "&establecimiento=" + process.env.VUE_APP_EPA;
        params += "&curso";
        params += "&materia";

        let resultado = API.enviar("get", "guardarNotaFinal", params);

        resultado
          .then((result) => {
            if (result.data.msj == "ok") {
              //console.log("nota final guardada");
              this.$emit("itemAlumno:recargarNotas");
            }
          })
          .catch((error) => {
            console.log("catch guardar nota final: ", error);
          });
      }
    },
    guardarActualizarMateriaPrevia: function (estado) {
      let params = "idAlumno=" + this.idalumno;
      params += "&idAgrupamientoMateria=" + this.materia;
      //params += "&periodo=" + API.PERIODO_ACTUAL;
      params += "&fecha=" + API.FECHA_ACTUAL;
      //params += "&establecimiento=" + API.ESTABLECIMIENTO;
      params += "&curso";
      params += "&materia";
      params += "&estado=" + estado;

      let resultado = API.enviar(
        "get",
        "guardarActualizarMateriaPrevia",
        params
      );

      return resultado;
    },
    verificarNotaFebrero: function (id_grupo, id_nota, nota) {
      //console.log("verificarNotaFebrero");
      let resultado = "";
      if (nota < 7 && nota != "") {
        resultado = this.guardarActualizarMateriaPrevia(1);
      } else {
        resultado = this.guardarActualizarMateriaPrevia(0);
      }

      resultado
        .then(() => {
          //console.log("verificarNotaFebrero then");
          this.guardarNota(id_grupo, id_nota, nota);
        })
        .catch((error) => {
          console.log("verificarNotaFebrero catch", error);
        });

      //guardarNota();
    },
  },
  watch: {
    nota_consolidada: function () {
      this.verificarConsolidacionNota();
    },
    notaDiciembre: function () {
      this.calcularNotaFinal();
    },
    notaFebMar: function () {
      this.calcularNotaFinal();
    },
    gruposNotas: function () {
      this.calcularPromedioGeneral();
      this.verificarConsolidacionNota();
    },
  },
};
</script>s


<style scoped>
.nombre {
  padding: 5px;
}

.textoCentrado {
  text-align: center !important;
}

input {
  width: 97%;
  border: #ccc solid 1px;
  /*padding: 1px;*/
  text-align: center;
}

.deshabilitado {
  background: #dddddd;
}

.aprueba {
  /*background-color: #cef6e3;*/
  background-color: #cef6ce;
}
.no_aprueba {
  /*background-color: #f6e3ce;*/
  background-color: #f6cece;
}

.especial {
  /* background-color: #f6e3ce; */
  background-color: #f5f6ce;
}

.colorHeaders {
  color: #fff;
  font-weight: bold;
  background-color: #4caf50;
  opacity: 0.7;
  margin: 2px;

  /*padding-left: 5px;*/
}

.borde-grupo-notas {
  border-right: solid 2px rgba(76, 174, 79, 0.7);
}

.consolidar_icono_green {
  color: #4caf50;
  cursor: pointer;
}

.consolidar_icono_yellow {
  color: #e0e137;
}

.ocultar_elemento {
  visibility: hidden;
}
</style>